import Cookies from 'js-cookie';

const COOKIE_KEY = 'DEV_ENVIRONMENT_ADMIN';

const RUNTIME_ENV_TO_DEV_NAME = {
    staging: 'STAGING',
    preproduction: 'PREPRODUCTION',
};

export const DEV_ENVIRONMENTS = [
    {
        name: 'PRODUCTION',
        config: {
            ADMIN_API_URL: 'https://be-cfm.forcemanager.net/api',
            BACKEND2_API_URL: 'https://be-pro.forcemanager.net',
            WEBAPP_URL: 'https://app.forcemanager.net',
            CFM_URL: 'https://cfm.forcemanager.net/Login.aspx',
        },
    },
    {
        name: 'PREPRODUCTION',
        config: {
            ADMIN_API_URL: 'https://be-cfmpre.forcemanager.net/api',
            BACKEND2_API_URL: 'https://be-pre.forcemanager.net',
            WEBAPP_URL: 'https://app-pre.forcemanager.net',
            CFM_URL: 'https://cfm-pre.forcemanager.net/Login.aspx',
        },
    },
    {
        name: 'STAGING',
        config: {
            ADMIN_API_URL: 'https://be-cfmsta.forcemanager.net/api',
            BACKEND2_API_URL: 'https://be-sta.forcemanager.net',
            WEBAPP_URL: 'https://app-sta.forcemanager.net',
            CFM_URL: 'https://cfm-sta.forcemanager.net/Login.aspx',
        },
    },
];

const getRuntimeEnv = () => window?.FM_CONFIG?.ENV || process.env.ENV;

/** Runtime ENV from FM_CONFIG (deploy) or process.env (local). Never trust build-time alone. */
export const isDevEnvironmentSwitcherEnabled = () => {
    if (process.env.NODE_ENV === 'development') return true;

    const env = getRuntimeEnv();
    return env === 'staging' || env === 'preproduction';
};

const getDefaultDevEnvironmentName = () => {
    if (process.env.NODE_ENV === 'development') return 'PREPRODUCTION';

    return RUNTIME_ENV_TO_DEV_NAME[getRuntimeEnv()] || null;
};

export const getDevEnvironmentOverride = () => Cookies.get(COOKIE_KEY) || '';

/** Selected env in the switcher: manual override or deploy default. */
const getActiveDevEnvironment = () => getDevEnvironmentOverride() || getDefaultDevEnvironmentName();

/** True when the user picked a different backend than the deploy default. */
export const hasDevEnvironmentOverride = () => Boolean(getDevEnvironmentOverride());

export const loadDevEnvironment = (key) => {
    if (!isDevEnvironmentSwitcherEnabled()) return;

    const override = key || getDevEnvironmentOverride();
    if (!override && process.env.NODE_ENV !== 'development') return;

    const configKey = override || getDefaultDevEnvironmentName();
    if (!configKey) return;

    window.FM_CONFIG = {
        ...(window.FM_CONFIG || {}),
        ...(DEV_ENVIRONMENTS.find((item) => configKey === item.name)?.config || {}),
    };
};

/** @deprecated Use getDevEnvironmentOverride */
const getDevEnvironment = () => getDevEnvironmentOverride();

export const setDevEnvironment = (key = '') => {
    const cookieOptions = { path: '/', secure: true, sameSite: 'Strict' };

    if (key) {
        Cookies.set(COOKIE_KEY, key, cookieOptions);
        return;
    }

    Cookies.remove(COOKIE_KEY, cookieOptions);
};
